export default "__VITE_ASSET__D$SfJ7hr__"